// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../../public/img/dust_scratches.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#navigatorСode-content {
  margin-left: 2vw;
  margin-right: 2vw;
  display: grid;
  padding: 0.2% 0.6% 0.3%;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  box-shadow:
    0 4px 8px 0 rgba(0, 0, 0, 0.2),
    0 6px 20px 0 rgba(0, 0, 0, 0.19);
  min-height: 100vh;
  width: auto;
}
.navigatorСode-conteiner {
 display: grid;
  grid-template-rows: auto 1fr;
  align-items: start;
  height: 100%; 
  width: 100%;
  min-width: 0;
}

.navigatorСode-mainsubtitle {
    position: relative;
    left: 40vw;
    font-family: "Amatic SC";
    font-size: 3vw;
}

.navigatorСode-titleGame {
  display: grid;
  grid-template-columns: 20vw auto;
}
.navigatorСode-game-wrapper {
  display: grid;
  grid-template-columns: 76% auto;
  gap: 2vw;
}
.navigatorСode-Scene{
  display: flex;
    flex-direction: column;
    gap: 2vw;
  min-width: 0;
  min-height: 0;
  height: -moz-fit-content;
  height: fit-content;
}
.navigatorСode-fullscreen {
  display: grid;
  height: 1.5vw;
  justify-self: end;
  position: relative;
}
`, "",{"version":3,"sources":["webpack://./src/TaskWindows/NavigatorСode/styles/Navigator%D0%A1odeApp.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,uBAAuB;EACvB,yDAAgE;EAChE;;oCAEkC;EAClC,iBAAiB;EACjB,WAAW;AACb;AACA;CACC,aAAa;EACZ,4BAA4B;EAC5B,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,YAAY;AACd;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,wBAAwB;IACxB,cAAc;AAClB;;AAEA;EACE,aAAa;EACb,gCAAgC;AAClC;AACA;EACE,aAAa;EACb,+BAA+B;EAC/B,QAAQ;AACV;AACA;EACE,aAAa;IACX,sBAAsB;IACtB,QAAQ;EACV,YAAY;EACZ,aAAa;EACb,wBAAmB;EAAnB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,aAAa;EACb,iBAAiB;EACjB,kBAAkB;AACpB","sourcesContent":["#navigatorСode-content {\n  margin-left: 2vw;\n  margin-right: 2vw;\n  display: grid;\n  padding: 0.2% 0.6% 0.3%;\n  background-image: url(../../../../public/img/dust_scratches.png);\n  box-shadow:\n    0 4px 8px 0 rgba(0, 0, 0, 0.2),\n    0 6px 20px 0 rgba(0, 0, 0, 0.19);\n  min-height: 100vh;\n  width: auto;\n}\n.navigatorСode-conteiner {\n display: grid;\n  grid-template-rows: auto 1fr;\n  align-items: start;\n  height: 100%; \n  width: 100%;\n  min-width: 0;\n}\n\n.navigatorСode-mainsubtitle {\n    position: relative;\n    left: 40vw;\n    font-family: \"Amatic SC\";\n    font-size: 3vw;\n}\n\n.navigatorСode-titleGame {\n  display: grid;\n  grid-template-columns: 20vw auto;\n}\n.navigatorСode-game-wrapper {\n  display: grid;\n  grid-template-columns: 76% auto;\n  gap: 2vw;\n}\n.navigatorСode-Scene{\n  display: flex;\n    flex-direction: column;\n    gap: 2vw;\n  min-width: 0;\n  min-height: 0;\n  height: fit-content;\n}\n.navigatorСode-fullscreen {\n  display: grid;\n  height: 1.5vw;\n  justify-self: end;\n  position: relative;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
